var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.localDrug
        ? [
            _c(
              "form",
              {
                attrs: { action: "" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.createOrder.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "text-left" },
                  [
                    _vm.ordered.length
                      ? _c("OrderedInvoices", {
                          attrs: {
                            orders: _vm.ordered,
                            costPrice: _vm.costPrice,
                            suppliers: _vm.suppliers,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-left" }),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-hover table-sm mt-1" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        !Object.keys(_vm.getSortedOrders()).length
                          ? [_vm._m(1)]
                          : _vm._l(
                              _vm.getSortedOrders(),
                              function (orders, cId_text) {
                                return [
                                  _c("tr", { staticClass: "country_tr" }, [
                                    _c("td", { attrs: { colspan: "20" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$AllCountries[orders.country_id]
                                            .name
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(orders.orders, function (o) {
                                    return _c(
                                      "tr",
                                      { class: { ordered: o.ordered } },
                                      [
                                        !o.toDelete
                                          ? [
                                              _c("td", [
                                                o.ordered
                                                  ? _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-check-circle",
                                                    })
                                                  : _vm._e(),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c(
                                                  "select",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: o.supplier.id,
                                                        expression:
                                                          "o.supplier.id",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: { disabled: "" },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        var $$selectedVal =
                                                          Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function (o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function (o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                        _vm.$set(
                                                          o.supplier,
                                                          "id",
                                                          $event.target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        )
                                                      },
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.suppliers,
                                                    function (s) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          domProps: {
                                                            value: s.id,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(s.title) +
                                                              "\n                    (" +
                                                              _vm._s(
                                                                _vm
                                                                  .$AllCountries[
                                                                  s.country_id
                                                                ] &&
                                                                  _vm
                                                                    .$AllCountries[
                                                                    s.country_id
                                                                  ].title
                                                              ) +
                                                              ")\n                    "
                                                          ),
                                                          _vm.drugPrices &&
                                                          _vm.drugPrices[s.id]
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.printDate(
                                                                      _vm
                                                                        .drugPrices[
                                                                        s.id
                                                                      ]
                                                                        .updated_at,
                                                                      "DD/MM"
                                                                    )
                                                                  )
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              false
                                                ? _c(
                                                    "td",
                                                    [
                                                      _c(
                                                        "v-popover",
                                                        {
                                                          attrs: {
                                                            placement: "left",
                                                            trigger: "hover",
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "icon-fa icon-fa-info-circle pointer",
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "template",
                                                            { slot: "popover" },
                                                            [
                                                              _vm.invoices[
                                                                o.supplier.id
                                                              ]
                                                                ? [
                                                                    _c("p", [
                                                                      _vm._v(
                                                                        "накладная "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .invoices[
                                                                                o
                                                                                  .supplier
                                                                                  .id
                                                                              ]
                                                                                .id
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("p", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.printDate(
                                                                            _vm
                                                                              .invoices[
                                                                              o
                                                                                .supplier
                                                                                .id
                                                                            ]
                                                                              .delivery_date
                                                                          )
                                                                        ) +
                                                                          "\n                        "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm
                                                                                .invoices[
                                                                                o
                                                                                  .supplier
                                                                                  .id
                                                                              ]
                                                                                .income_price
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                : [
                                                                    _c("p", [
                                                                      _vm._v(
                                                                        "накладная поступления не найдена"
                                                                      ),
                                                                    ]),
                                                                  ],
                                                            ],
                                                            2
                                                          ),
                                                        ],
                                                        2
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c(
                                                  "div",
                                                  { staticClass: "flex" },
                                                  [
                                                    _vm.drugPrices[
                                                      o.supplier.id
                                                    ]?.link
                                                      ? _c(
                                                          "a",
                                                          {
                                                            staticClass: "mr-1",
                                                            attrs: {
                                                              href: `${
                                                                _vm.drugPrices[
                                                                  o.supplier.id
                                                                ].link
                                                              }`,
                                                              target: "_blank",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "icon-fa icon-fa-globe",
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.drugPrices[
                                                      o.supplier.id
                                                    ]?.extra_data?.outOfStore
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-warning mr-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "нет в наличии"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.drugPrices[
                                                      o.supplier.id
                                                    ]?.pzn &&
                                                    !_vm.drugPrices[
                                                      o.supplier.id
                                                    ]?.extra_data?.productExist
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-danger mr-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "не активный"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.drugPrices[
                                                      o.supplier.id
                                                    ]?.error
                                                      ? _c(
                                                          "v-popover",
                                                          {
                                                            attrs: {
                                                              placement:
                                                                "right",
                                                              trigger: "hover",
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "color_dark_red pointer icon-fa icon-fa-warning",
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "popover",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .drugPrices[
                                                                        o
                                                                          .supplier
                                                                          .id
                                                                      ].error
                                                                    ) +
                                                                    "\n                    "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          2
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.getSupplierDiscount(
                                                        o.supplier.id
                                                      )
                                                    ) +
                                                    "\n              "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: o.price,
                                                      expression: "o.price",
                                                    },
                                                  ],
                                                  staticClass: "form-control",
                                                  domProps: { value: o.price },
                                                  on: {
                                                    keyup: function ($event) {
                                                      return _vm.updatePriceDecimal(
                                                        o
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        o,
                                                        "price",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("input", {
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "number",
                                                    disabled: "",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.discountedPrice(o),
                                                  },
                                                }),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: o.qty,
                                                      expression: "o.qty",
                                                    },
                                                  ],
                                                  ref: "newQty",
                                                  refInFor: true,
                                                  staticClass: "form-control",
                                                  attrs: { type: "number" },
                                                  domProps: { value: o.qty },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        o,
                                                        "qty",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c("input", {
                                                  staticClass: "form-control",
                                                  attrs: {
                                                    type: "number",
                                                    disabled: "",
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.discountedPrice(o) *
                                                      o.qty,
                                                  },
                                                }),
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c(
                                                  "div",
                                                  { staticClass: "text-left" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group mb-0",
                                                      },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                o.useExpireDateComment,
                                                              expression:
                                                                "o.useExpireDateComment",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "checkbox",
                                                            id: `ch_d_${o.supplier.id}`,
                                                          },
                                                          domProps: {
                                                            checked:
                                                              Array.isArray(
                                                                o.useExpireDateComment
                                                              )
                                                                ? _vm._i(
                                                                    o.useExpireDateComment,
                                                                    null
                                                                  ) > -1
                                                                : o.useExpireDateComment,
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    o.useExpireDateComment,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      null,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      _vm.$set(
                                                                        o,
                                                                        "useExpireDateComment",
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        )
                                                                      )
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      _vm.$set(
                                                                        o,
                                                                        "useExpireDateComment",
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          )
                                                                      )
                                                                  }
                                                                } else {
                                                                  _vm.$set(
                                                                    o,
                                                                    "useExpireDateComment",
                                                                    $$c
                                                                  )
                                                                }
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.updateDateComment(
                                                                  o.supplier.id
                                                                )
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "pl-2 pointer",
                                                            attrs: {
                                                              for: `ch_d_${o.supplier.id}`,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Комм. срока годности"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    o.useExpireDateComment
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ml-3 flex",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "mr-1",
                                                              },
                                                              [
                                                                _c("div", [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            o.commentType,
                                                                          expression:
                                                                            "o.commentType",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-check-input",
                                                                    attrs: {
                                                                      type: "radio",
                                                                      id: `inlineRadio${o.supplier.id}_1`,
                                                                      value:
                                                                        "1",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        _vm._q(
                                                                          o.commentType,
                                                                          "1"
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      change: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.$set(
                                                                            o,
                                                                            "commentType",
                                                                            "1"
                                                                          )
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateDateComment(
                                                                            o
                                                                              .supplier
                                                                              .id
                                                                          )
                                                                        },
                                                                      ],
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      attrs: {
                                                                        for: `inlineRadio${o.supplier.id}_1`,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Дата больше"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("div", [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            o.commentType,
                                                                          expression:
                                                                            "o.commentType",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-check-input",
                                                                    attrs: {
                                                                      type: "radio",
                                                                      id: `inlineRadio${o.supplier.id}_2`,
                                                                      value:
                                                                        "2",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        _vm._q(
                                                                          o.commentType,
                                                                          "2"
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      change: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.$set(
                                                                            o,
                                                                            "commentType",
                                                                            "2"
                                                                          )
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateDateComment(
                                                                            o
                                                                              .supplier
                                                                              .id
                                                                          )
                                                                        },
                                                                      ],
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      attrs: {
                                                                        for: `inlineRadio${o.supplier.id}_3`,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Выбор года"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("div", [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            o.commentType,
                                                                          expression:
                                                                            "o.commentType",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-check-input",
                                                                    attrs: {
                                                                      type: "radio",
                                                                      id: `inlineRadio${o.supplier.id}_3`,
                                                                      value:
                                                                        "3",
                                                                    },
                                                                    domProps: {
                                                                      checked:
                                                                        _vm._q(
                                                                          o.commentType,
                                                                          "3"
                                                                        ),
                                                                    },
                                                                    on: {
                                                                      change: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.$set(
                                                                            o,
                                                                            "commentType",
                                                                            "3"
                                                                          )
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.updateDateComment(
                                                                            o
                                                                              .supplier
                                                                              .id
                                                                          )
                                                                        },
                                                                      ],
                                                                    },
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "label",
                                                                    {
                                                                      staticClass:
                                                                        "form-check-label",
                                                                      attrs: {
                                                                        for: `inlineRadio${o.supplier.id}_3`,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Текст"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("div", [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      o.expireDateComment,
                                                                    expression:
                                                                      "o.expireDateComment",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-control",
                                                                attrs: {
                                                                  type: "text",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    o.expireDateComment,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.$set(
                                                                        o,
                                                                        "expireDateComment",
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("td"),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    )
                                  }),
                                ]
                              }
                            ),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", { attrs: { type: "submit", hidden: "" } }),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c("table", { staticClass: "table table-sm table-hover" }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th", [_vm._v("PZN")]),
                  _vm._v(" "),
                  _vm._l(_vm.suppliers, function (supp, ii) {
                    return _c("th", { key: `s_${ii}` }, [
                      _vm._v("\n        " + _vm._s(supp.title) + "\n        "),
                      _c("p", { staticClass: "text-muted" }, [
                        _vm._v("max: " + _vm._s(supp.max_qty)),
                      ]),
                    ])
                  }),
                  _vm._v(" "),
                  _c("th"),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.prices, function (price, pzn, i) {
                return _c(
                  "tr",
                  { key: i },
                  [
                    _c("td", [
                      _c("strong", [_vm._v(_vm._s(pzn))]),
                      _vm._v(" "),
                      _vm.pznDetails &&
                      _vm.pznDetails[pzn] &&
                      _vm.pznDetails[pzn].comment
                        ? _c("p", [
                            _vm._v(
                              _vm._s(_vm.pznDetails[pzn].comment.text_value)
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.suppliers, function (supp, ii) {
                      return _c(
                        "td",
                        { key: `s_${ii}_${i}` },
                        [
                          price[supp.id] && price[supp.id].price
                            ? [
                                _c("p", [
                                  _vm._v("цена: "),
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        badge: true,
                                        "badge-success":
                                          _vm.costPrice > price[supp.id].price,
                                      },
                                    },
                                    [
                                      _c("strong", { staticClass: "price" }, [
                                        _vm._v(_vm._s(price[supp.id].price)),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: `${price[supp.id].link}`,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-globe",
                                      }),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.printDate(
                                        price[supp.id].updated_at,
                                        "DD.MM.YYYY HH:mm"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.orderQty[pzn][supp.id].qty,
                                      expression: "orderQty[pzn][supp.id].qty",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "number" },
                                  domProps: {
                                    value: _vm.orderQty[pzn][supp.id].qty,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateTotalOrder(pzn)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.orderQty[pzn][supp.id],
                                        "qty",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _c("td", [
                      _c("p", [
                        _vm._v("требуется: "),
                        _c("strong", [_vm._v(_vm._s(_vm.requiredQty))]),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("заказ: "),
                        _c("strong", [_vm._v(_vm._s(_vm.totalOrdered[pzn]))]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default btn-xs",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.makeSmartOrder(pzn)
                            },
                          },
                        },
                        [_vm._v("Распределить")]
                      ),
                    ]),
                  ],
                  2
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("\n            Поставщик\n          ")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Скидка %")]),
        _vm._v(" "),
        _c("th", [_vm._v("Цена")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ц. Скидка")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сумма")]),
        _vm._v(" "),
        _c("th", { staticClass: "comment_block" }),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "15" } }, [
        _c("p", [_vm._v("Нет активных поставщиков страны закупки препарата")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }